import { SvgIcon, type SvgIconProps } from '@mui/material';

const FirstPaginationItemSvg = (properties: SvgIconProps) => (
  <SvgIcon {...properties}>
    <svg
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.22 6.718a.75.75 0 0 1-.22-.53v-.38a.77.77 0 0 1 .22-.53L5.36.148a.5.5 0 0 1 .71 0l.71.71a.49.49 0 0 1 0 .7l-4.45 4.44 4.45 4.44a.5.5 0 0 1 0 .71l-.71.7a.5.5 0 0 1-.71 0z"
        fill="currentColor"
      />
      <path
        d="M5.22 6.718a.75.75 0 0 1-.22-.53v-.38a.77.77 0 0 1 .22-.53l5.14-5.13a.5.5 0 0 1 .71 0l.71.71a.49.49 0 0 1 0 .7l-4.45 4.44 4.45 4.44a.5.5 0 0 1 0 .71l-.71.7a.5.5 0 0 1-.71 0z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default FirstPaginationItemSvg;
